export default __webpack_public_path__ + "static/figure-gallery-5-reference-96e786a17e9170a8376ddc63887bfec0.jpg";